/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable max-lines */
import { BreakMessage } from "../../../../../../../_webui/layout/components/Typography/BreakMessage"
import { UploadFileType } from "../../../../../../../_webui/layout/components/Upload/models"
import { File } from "../../../../../../../constant/File"
import { Routers } from "../../../../../../../constant/Routers"
import { Translate } from "../../../../../../../constant/Translate"
import { AxiosErrorType } from "../../../../../../../infrastructure/axiosError/models"
import { openNotification } from "../../../../../../../utils/openNotification"
import { pushStateError } from "../../../../../../../utils/pushStateError"
import { TravelersFileAddBatchImportType } from "../../../../../travelers/models/batchImport"
import { scheduleApi } from "../../../../apis"
import {
  SchedulesBatchImportCheck,
  SchedulesBatchImportDataResType,
  SchedulesBatchImportErrorType,
  UseSchedulesBatchImportApiProps,
} from "../../../../models/batchImport"
import { useVariablesApi } from "../useVariablesApi"
import { convertDataSource } from "./convertDataSource"
import { getFileNameRcFile } from "../../../../../../../utils/getFileNameRcFile"

const { SCR220: SCR220_URL, SCR973 } = Routers
const { MESSAGE_I0012, MESSAGE_E0022, MESSAGE_E0023, MESSAGE_E0037 } = Translate
const {
  FILE_COLUMN_LIMIT_SCHEDULES,
  FILE_COLUMN_LIMIT_SCHEDULES_USER,
  FILE_SIZE_LIMIT_KB,
  FILE_SIZE_LIMIT_MB,
  FILE_TYPE_ALLOW,
  SCR220,
  SCR220_MENU_ID,
  SCR220_USER_MENU_ID,
} = File

export const useApi = (props: UseSchedulesBatchImportApiProps) => {
  const { onCancel, onCancelUploaded } = props
  const {
    countRecord,
    dataTemps,
    errorList,
    fileNameList,
    isDisabledSubmit,
    isLoading,
    isLoadingLayout,
    isResetTable,
    onChange,
    pathname,
    perItem,
    push,
    setCountRecord,
    setDataTemps,
    setErrorList,
    setFileNameList,
    setIsDisabledSubmit,
    setIsLoading,
    setIsLoadingLayout,
    setIsResetTable,
  } = useVariablesApi()

  const handlePushStateError = (error: AxiosErrorType) => {
    const stateError = pushStateError(error)
    push({ pathname: SCR973, state: stateError })
  }

  const bulkCheck = () => {
    // APIを呼び出し、APIからの応答結果を「一括チェック応答」変数に設定する。
    scheduleApi
      .bulkCheck(SCR220)
      .then((bulkCheckTemp: SchedulesBatchImportCheck) => {
        const { message } = bulkCheckTemp
        if (message) {
          //「TBL_TEMP_FOR_UPLOAD」一時テーブルのデータ削除の確認ダイアログを表示する。
          bulkDeleteData()
        } else {
          setIsLoadingLayout(false)
        }
      })
      .catch((error: AxiosErrorType) => {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        handlePushStateError(error)
      })
  }

  const bulkData = () => {
    setIsLoading(true)
    setIsResetTable(true)
    setTimeout(() => {
      // APIを呼び出し、APIからの応答結果を「返却一時データ」変数に設定する。
      scheduleApi
        .bulkData(SCR220)
        .then((dataTempsResponse: SchedulesBatchImportDataResType[]) => {
          //「M.dataTemps」の一覧にデータを設定する。
          const _res = convertDataSource(dataTempsResponse)
          sessionStorage.setItem("dataUpload", SCR220)
          setDataTemps(_res)
          setErrorList([])
          onChange(1, 25)
        })
        .catch((error: AxiosErrorType) => {
          // 「SCR973_エラー情報の表示画面」に遷移する。
          handlePushStateError(error)
        })
        .finally(() => {
          setIsLoading(false)
          setIsDisabledSubmit(false)
          setIsResetTable(false)
        })
    }, 500)
  }

  const bulkAdd = () => {
    const menuId =
      pathname === SCR220_URL ? SCR220_MENU_ID : SCR220_USER_MENU_ID
    setIsLoading(true)
    setTimeout(() => {
      // APIを呼び出し、APIからの応答結果を「一括追加応答」変数に設定する。
      scheduleApi
        .bulkAdd(menuId)
        .then((bulkRes: SchedulesBatchImportErrorType) => {
          // ComponentErrorを表示する。
          if (bulkRes.errors.length) {
            setErrorList(bulkRes.errors)
          }

          // バックエンドから戻す「I0012」のメッセージを表示する。
          if (bulkRes?.execute?.fail === 0) {
            openNotification(MESSAGE_I0012)
            setDataTemps([])
          }

          //「渡航者情報の結果件数」コンポーネントの値を表示する。
          sessionStorage.removeItem("dataUpload")
          setCountRecord(bulkRes.execute)
          setIsLoading(false)
          setIsDisabledSubmit(true)
          bulkDeleteData()
        })
        .catch((error: AxiosErrorType) => {
          // 「SCR973_エラー情報の表示画面」に遷移する。
          handlePushStateError(error)
        })
    }, 500)
  }

  const bulkDeleteData = () => {
    // APIを呼び出し、APIからの応答結果を「一時削除応答」変数に設定する。
    scheduleApi
      .bulkDeleteData(SCR220)
      .then(() => {
        // モーダルクローズを実行する
        sessionStorage.removeItem("dataUpload")
        onCancelUploaded()
        onCancel()
        setIsLoadingLayout(false)
      })
      .catch((error: AxiosErrorType) => {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const stateError = pushStateError(error)
        push({ pathname: SCR973, state: stateError })
      })
  }

  const setDataBeforeUploadError = (message: string, validValue: string) => {
    openNotification(<BreakMessage message={message} validValue={validValue} />)
    setErrorList([])
    setDataTemps([])
    setFileNameList([])
  }

  const bulkFileAdd = (fileInfoCSV: UploadFileType) => {
    const formData = new FormData()
    formData.append("file", fileInfoCSV)
    setIsLoading(true)
    setIsResetTable(true)
    // APIを呼び出し、APIからの応答結果を「一時アップロード応答」変数に設定する。
    scheduleApi
      .bulkFileAdd(formData)
      .then((uploadTemp: SchedulesBatchImportErrorType) => {
        // バックエンドから戻す「E0037」のメッセージが表示される。
        onChangeUploadFile({ response: uploadTemp, status: "done" })
        if (getFileNameRcFile(fileInfoCSV)) {
          setFileNameList([fileInfoCSV?.name])
        }
      })
      .catch((error) => {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        onChangeUploadFile({ response: error, status: "error" })
        setFileNameList([])
      })
      .finally(() => {
        setIsLoading(false)
        setIsResetTable(false)
      })
  }

  const beforeUpload = (
    fileInfoCSV: UploadFileType,
    uploadCallback: (upload: boolean) => void,
  ) => {
    if (typeof fileInfoCSV !== "string") {
      const { type, size } = fileInfoCSV
      const fileSize = size / 1024
      const isValidFileType = type.includes(FILE_TYPE_ALLOW)
      const isValidFileSize = fileSize < FILE_SIZE_LIMIT_KB
      const isValidFileSizeZero = fileSize === 0

      // ファイル拡張子のバリデーションチェックを行う。
      if (!isValidFileType) {
        setDataBeforeUploadError(MESSAGE_E0022, FILE_TYPE_ALLOW)
        uploadCallback(false)
        return false
      }

      // ファイルサイズのバリデーションチェックを行う。
      if (!isValidFileSize) {
        setDataBeforeUploadError(MESSAGE_E0023, String(FILE_SIZE_LIMIT_MB))
        uploadCallback(false)
        return false
      }

      // ファイルの項目個数のバリデーションチェックを行う。
      if (isValidFileSizeZero) {
        setDataBeforeUploadError(
          MESSAGE_E0037,
          String(FILE_COLUMN_LIMIT_SCHEDULES),
        )
        uploadCallback(false)
        return false
      }

      const reader = new FileReader()
      reader.onload = (event: ProgressEvent<FileReader>) => {
        // ファイルのデータを読み込み、受け取ったカラム数を「columns」変数に保存する。
        const fileData = String(event.target?.result)
        const columnNames = fileData?.substring(0, fileData.indexOf("\r\n"))
        const columns = columnNames.split(",")

        const columnLimit =
          pathname === SCR220_URL
            ? FILE_COLUMN_LIMIT_SCHEDULES_USER
            : FILE_COLUMN_LIMIT_SCHEDULES
        const isValidColumns = columns.length === columnLimit

        if (!isValidColumns) {
          // ファイルの項目個数のバリデーションチェックを行う。
          setDataBeforeUploadError(MESSAGE_E0037, String(columnLimit))
          uploadCallback(false)
        } else {
          uploadCallback(true)
        }
      }

      reader.readAsText(fileInfoCSV)
    }
  }
  const onChangeUploadFile = (info: TravelersFileAddBatchImportType) => {
    const { status, response } = info
    if (status === "done") {
      if (response.errors?.length) {
        setErrorList(response.errors)
        setIsDisabledSubmit(true)
      } else {
        bulkData()
      }
      setCountRecord(response?.execute)
    } else if (status === "error") {
      setDataBeforeUploadError(
        MESSAGE_E0037,
        String(FILE_COLUMN_LIMIT_SCHEDULES),
      )
      setIsDisabledSubmit(true)
    }
  }

  return {
    beforeUpload,
    bulkAdd,
    bulkCheck,
    bulkDeleteData,
    bulkFileAdd,
    countRecord,
    dataTemps,
    errorList,
    fileNameList,
    isDisabledSubmit,
    isLoading,
    isLoadingLayout,
    isResetTable,
    onChange,
    perItem,
  }
}
